import AssetProcessingSkeleton, { type AssetSkeletonColumn } from '@/matter-asset-common/asset/AssetProcessingSkeleton'

/**
 * Skeleton table shown while the first chronology build is in flight
 * (Figma: Table/MedChron/Loading, node 8744:82715). Thin wrapper over the shared
 * AssetProcessingSkeleton that supplies the med-chron column set.
 */

// Mirrors the All Events columns of MedChronEventsTable (rowNumber + the
// non-detailed-view columns), with their fixed widths. Kept aligned to the LIVE
// table's column set so columns don't shift when data lands. (Figma's loading
// frame shows a phantom 6th "Comments" column and slightly different widths —
// number 30/Summary 587 — that the live ALL_EVENTS table never renders; matching
// Figma there would reintroduce the very layout shift this skeleton avoids.)
const SKELETON_COLUMNS: AssetSkeletonColumn[] = [
  { width: 35, label: '' },
  { width: 134, label: 'Date of Service' },
  { width: 172, label: 'Facility' },
  { width: 578, label: 'Summary' },
  { width: 297, label: 'Source File' },
]

export default function MedChronAssetProcessingSkeleton() {
  return <AssetProcessingSkeleton columns={SKELETON_COLUMNS} />
}
